import { apiHost } from "./utils/api-host-resolver"
import { API_PATH, TOKEN } from "./constants"

export const getAllAccountsWithFFEnabled: (name: string) => Promise<any> =
    async (name: string) => {
        const token = localStorage.getItem(TOKEN)
        return await fetch(`${apiHost}${API_PATH}/ff/${name}/accounts`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
        })
            .then(resp => resp.json())
            .catch(e => console.log(e))
    }